(function () {
  var quantityControls = document.querySelectorAll(".qtyOpt");

  for (var i = 0; i < quantityControls.length; i++) {
    quantityControls[i].addEventListener("click", function () {
      var selectedOption = this.querySelector('input[name="qtyCtrl"]');
      // var quantityInput = document.querySelector('#Quantity-' + sectionId);
      var quantityInput = document.getElementsByClassName(
        "QuantitySelector__CurrentQuantity"
      )[0];

      if (selectedOption) {
        quantityInput.value = selectedOption.value;
      }

      document.dispatchEvent(new CustomEvent("cart:quantity:update"));
    });
  }
})();
